/*
 * SecondLap — barre de filtres.
 * Les menus sont des <details> : ils s'ouvrent et se ferment sans JS.
 * Ce script ne fait qu'ajouter le confort : un seul menu ouvert à la fois,
 * fermeture au clic extérieur ou à Échap, et recherche dans les longues listes.
 */
class SLFilterBar extends HTMLElement {
  connectedCallback() {
    this.drops = Array.from(this.querySelectorAll('[data-sl-drop]'));
    if (!this.drops.length) return;

    this.onDocPointer = this.onDocPointer.bind(this);
    this.onKeydown = this.onKeydown.bind(this);

    this.drops.forEach((drop) => {
      drop.addEventListener('toggle', () => {
        if (!drop.open) return;
        this.drops.forEach((other) => {
          if (other !== drop) other.open = false;
        });
        const search = drop.querySelector('[data-sl-fsearch]');
        if (search) search.focus();
      });
    });

    this.addEventListener('input', (event) => {
      if (event.target.matches('[data-sl-fsearch]')) this.filterList(event.target);
    });

    document.addEventListener('click', this.onDocPointer);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocPointer);
    document.removeEventListener('keydown', this.onKeydown);
  }

  onDocPointer(event) {
    if (this.contains(event.target)) return;
    this.closeAll();
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;
    const open = this.drops.find((drop) => drop.open);
    if (!open) return;
    this.closeAll();
    open.querySelector('summary')?.focus();
  }

  closeAll() {
    this.drops.forEach((drop) => {
      drop.open = false;
    });
  }

  filterList(input) {
    const panel = input.closest('.sl-fdrop__panel');
    if (!panel) return;

    const query = input.value.trim().toLowerCase();
    let shown = 0;

    panel.querySelectorAll('[data-sl-flist] > li').forEach((item) => {
      const label = item.querySelector('[data-sl-flabel]')?.textContent.toLowerCase() || '';
      const match = !query || label.includes(query);
      item.hidden = !match;
      if (match) shown += 1;
    });

    const none = panel.querySelector('[data-sl-fnone]');
    if (none) none.hidden = shown !== 0;
  }
}

if (!customElements.get('sl-filter-bar')) {
  customElements.define('sl-filter-bar', SLFilterBar);
}
